'use strict';

/**
 * Allows to lock an element to an area on the page. The included default one
 * does not work because it only checks one on page-load so if the page with
 * the affix does not get loaded directly it breaks. For that reason here a
 * custom version. Code got copied from:
 * https://stackoverflow.com/questions/23638925/bootstrap-data-spy-affix-not-working-on-angular-view-change
 */
angular.module('mobile-apps')
	.directive('affix', ['$rootScope', '$timeout', function($rootScope, $timeout) {
		return {
			link: function($scope, $element, $attrs) {

				function applyAffix() {
					$timeout(function() {
						$element.affix({ offset: { top: $attrs.affix } });
					});
				}

				$rootScope.$on('$stateChangeSuccess', function() {
					$element.removeData('bs.affix').removeClass('affix affix-top affix-bottom');
					applyAffix();
				});

				applyAffix();

			}
		};
	}]);
